import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { DependencyTreeGuard } from 'app/core/guards/dependency-tree.guard';
import { GetCCRGuard } from '../../core/store/edit-ccr-detail/ccr-detail.resolve';
import { CCREditContainer } from './ccr-edit-container/ccr-edit.container';

const routes: Routes = [
  {
    path: 'ccr/:etmOrderNumber/edit/:ccrNumber',
    component: CCREditContainer,
    canActivate: [DependencyTreeGuard],
    data: {
      guards: [GetCCRGuard],
      createOrEdit: 'edit',
    }
  },
  {
    path: 'ccr/:etmOrderNumber',
    component: CCREditContainer,
    canActivate: [DependencyTreeGuard],
    data: {
      guards: [GetCCRGuard],
      createOrEdit: 'create',
    },
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class CCRRoutingModule {}
